export interface GetFormattedPhoneNumberStringProps {
  phone: string,
}

export function GetFormattedPhoneNumberString({ phone }: GetFormattedPhoneNumberStringProps) {
  const cleaned = (`${phone}`).replace(/\D/g, '');
  const matchFull = cleaned.match(/^(\d{2})(\d{1,7})$/);
  if (matchFull) {
    return `+260 ${matchFull[1]} ${matchFull[2]}`;
  }
  return `+260 ${cleaned}`;
}
